/* tslint:disable */
import {
  App
} from '../index';

declare var Object: any;
export interface ReporttemplateInterface {
  name: string;
  description: string;
  dataelements?: Array<any>;
  templatehtml?: string;
  templatejs?: string;
  templatecss?: string;
  lastupdatedby?: string;
  createdby?: string;
  id?: any;
  appId?: any;
  createdAt: Date;
  updatedAt: Date;
  app?: App;
}

export class Reporttemplate implements ReporttemplateInterface {
  name: string;
  description: string;
  dataelements: Array<any>;
  templatehtml: string;
  templatejs: string;
  templatecss: string;
  lastupdatedby: string;
  createdby: string;
  id: any;
  appId: any;
  createdAt: Date;
  updatedAt: Date;
  app: App;
  constructor(data?: ReporttemplateInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Reporttemplate`.
   */
  public static getModelName() {
    return "Reporttemplate";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Reporttemplate for dynamic purposes.
  **/
  public static factory(data: ReporttemplateInterface): Reporttemplate{
    return new Reporttemplate(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Reporttemplate',
      plural: 'reporttemplates',
      properties: {
        name: {
          name: 'name',
          type: 'string'
        },
        description: {
          name: 'description',
          type: 'string'
        },
        dataelements: {
          name: 'dataelements',
          type: 'Array&lt;any&gt;'
        },
        templatehtml: {
          name: 'templatehtml',
          type: 'string'
        },
        templatejs: {
          name: 'templatejs',
          type: 'string'
        },
        templatecss: {
          name: 'templatecss',
          type: 'string'
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        appId: {
          name: 'appId',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        app: {
          name: 'app',
          type: 'App',
          model: 'App'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Reporttemplate.ts